import React from "react";

function StartAccepting() {
  const blockchains = [
    {
      name: "Bitcoin",
      img: "https://cryptologos.cc/logos/bitcoin-btc-logo.svg?v=035",
    },
    {
      name: "Ethereum",
      img: "https://cryptologos.cc/logos/ethereum-eth-logo.svg?v=035",
    },
    { name: "USDT", img: "https://cryptologos.cc/logos/usdt-logo.svg?v=035" },
    {
      name: "Solana",
      img: "https://cryptologos.cc/logos/solana-sol-logo.svg?v=035",
    },
    { name: "XRP", img: "https://cryptologos.cc/logos/xrp-xrp-logo.svg?v=035" },
    { name: "USDC", img: "https://cryptologos.cc/logos/usdc-logo.svg?v=035" },
  ];
  return (
    <>
      {/* Blockchain Platforms */}
      <div style={{ padding: "80px 0", background: "#f7f9fc" }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2
              className="fw-bold"
              style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}
            >
              Start Accepting a Wide Range of Cryptocurrencies
            </h2>
            <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
              We build crypto exchange solutions on all major blockchain
              networks to ensure maximum compatibility.
            </p>
          </div>
          <div className="d-flex flex-wrap justify-content-center gap-4">
            {blockchains.map((chain, idx) => (
              <div key={idx} className="ce-chain-card">
                <img
                  src={chain.img}
                  alt={chain.name}
                  style={{ width: "48px", height: "48px" }}
                />
                <span
                  className="fw-semibold"
                  style={{ fontSize: "13px", color: "#334155" }}
                >
                  {chain.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default StartAccepting;
